import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
    state: {
        user: npp_vars.current_user_id,
        user_role: npp_vars.current_user_role,
        facilityOptions: [],
        currentFacility: null,
        //currentDate: new Date(),
        currentDate: new Date(new Date().toLocaleString("en-US", {timeZone: npp_vars.timezone})),
        numberOfDays: 1,
        shifts: [],
        timezone: npp_vars.timezone,
        radioSelected: 'showEveryone',
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setUserRole(state, user_role) {
            state.user_role = user_role;
        },
        setFacilityOptions(state, facilities) {
            state.facilityOptions = facilities;
        },
        setCurrentFacility(state, facility) {
            state.currentFacility = facility;
        },
        incrementDate(state) {
            let date = new Date(state.currentDate);
            date.setDate(date.getDate() + 1);
            state.currentDate = new Date(date.toLocaleString("en-US", {timeZone: state.timezone}));
        },
        incrementDateByWeek(state) {
            let date = new Date(state.currentDate);
            date.setDate(date.getDate() + 7);
            state.currentDate = new Date(date.toLocaleString("en-US", {timeZone: state.timezone}));
        },
        decrementDate(state) {
            let date = new Date(state.currentDate);
            date.setDate(date.getDate() - 1);
            state.currentDate = new Date(date.toLocaleString("en-US", {timeZone: state.timezone}));
        },
        decrementDateByWeek(state) {
            let date = new Date(state.currentDate);
            date.setDate(date.getDate() - 7);
            state.currentDate = new Date(date.toLocaleString("en-US", {timeZone: state.timezone}));
        },
        setToday(state) {
            state.currentDate = new Date(new Date().toLocaleString("en-US", {timeZone: state.timezone}));
        },
        setCurrentDate(state, date) {
            date = new Date(date);  // Ensure date is a Date object
            state.currentDate = new Date(date.toLocaleString("en-US", {timeZone: state.timezone}));
        },
        setShifts(state, shifts) {
            state.shifts = shifts;
        },
        setNumberOfDays(state, numberOfDays) {
            state.numberOfDays = numberOfDays;
        },
        setRadioSelected(state, value) {
            state.radioSelected = value;
        },
    },
    actions: {
        fetchFacilities({ commit, state }) {
            axios.get('/wp-json/npp/v1/connectedFacilities/' + state.user)
                .then(response => {
                    commit('setFacilityOptions', response.data);
                })
                .catch(error => {
                    console.error(error);
                });
        },
        async fetchShifts({ commit, getters }) {
            const params = {
                user: getters.getUser,
                date: getters.getCurrentDate,
                facility: getters.getCurrentFacility.value, // this is the id of the facility.
                days: getters.getNumberOfDays,
            };
            
            try {
                const response = await axios.get('/wp-json/npp/v1/shifts', { params });
                commit('setShifts', response.data);
                
            } catch (error) {
                console.error(error);
            }
        },
        updateNumberOfDays({ commit, dispatch }, numberOfDays) {
            commit('setNumberOfDays', numberOfDays);
            dispatch('fetchShifts');
        },
        updateRadioSelected({ commit }, value) {
            commit('setRadioSelected', value);
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getUserRole(state) {
            return state.user_role;
        },
        getFacilityOptions(state) {
            return state.facilityOptions;
        },
        getCurrentFacility(state) {
            return state.currentFacility;
        },
        getCurrentDate(state) {
            return state.currentDate;
        },
        isCurrentDateToday(state) {
            let today = new Date();
            today.setHours(0, 0, 0, 0);  // Set time to 00:00:00.000
        
            let currentDate = new Date(state.currentDate.getTime());
            currentDate.setHours(0, 0, 0, 0);  // Set time to 00:00:00.000
        
            return currentDate.getTime() === today.getTime();
        },
        getShifts(state) {
            return state.shifts;
        },
        getNumberOfDays(state) {
            return state.numberOfDays;
        },
        getTimezone(state) {
            return state.timezone;
        },
        getRadioSelected(state) {
            return state.radioSelected;
        },
    }
})